import tochtApi from "../../../api/e-loket/tochtApi";
import tochtTypeApi from "../../../api/shared/tochtTypeApi";
import redirector from "../../../util/redirector";
import * as messages from "../../../constants/ToastrConstants";
import { showToastrSuccess, showToastrError } from "../../../util/toastr.js";
import { getState } from "../../../store/configureStore.js";

export default class VTTPerOrganisatorPageHelper {

    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        const params = context.props.match.params;
        const disabled = params.isDisabled || false;

        //todo check if this is necessary? Please take look at the code when copy pasting..
        const returnUrl = decodeURIComponent(context.props.match.params.returnUrl);

        this.loadModel(ajaxActions);
        this.loadTochtTypes(ajaxActions);

        context.setState({
            returnUrl,
            disabled,
            modalIsOpen: false
        });
    }

    loadModel(ajaxActions) {
        const context = this.context;

        ajaxActions.started();
        tochtApi.getAllByOrganisator()
                .then((response) => {
                    ajaxActions.ended();
                    this.processModel(response, false);
                })
                .catch((ex) => {
                    ajaxActions.failed();
                    if (ex.response.status === 406) {
                        context.props.throwException("Je hebt geen toegang tot deze pagina", true);
                    }
                    else {
                        context.props.throwException(ex);
                    }
                });
    }

    loadTochtTypes(ajaxActions) {
        const context = this.context;

        ajaxActions.started();
        tochtTypeApi.getTochtTypes()
                .then((response) => {
                    ajaxActions.ended();
                    context.setState({ tochtTypes: response.data });
                })
                .catch((ex) => {
                    ajaxActions.failed();
                    context.props.throwException(ex);
                });
    }

    onModalOpen(id, tochtTypeTekst) {
        const context = this.context;
        context.setState({
            modalIsOpen: true,
            modalEntityId: id,
            deleteTochtTypeTekst: tochtTypeTekst
        });
    }

    onModalClose() {
        const context = this.context;
        context.setState({
            modalIsOpen: false,
            modalEntityId: null,
            tochtTypeTekst: 'tocht'
        });
    }

    onDelete(entityId) {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        ajaxActions.started();
            tochtApi.deleteTocht(entityId)
                .then((response) => {
                    ajaxActions.ended();
                    showToastrSuccess(messages.MESSAGE_TOCHT_VERWIJDERD);
                    this.loadModel(ajaxActions);
                })
                .catch((ex) => {
                    ajaxActions.failed();
                    //context.props.throwException(ex);
                    showToastrError(messages.MESSAGE_ERROR);
                });

        context.setState({
            modalIsOpen: false,
            modalEntityId: null
        });
    }

    processModel(response, isNew) {
        const context = this.context;
        let model = response.data;

        context.setState({
            model
        });

        context.props.loadLayout(model.organisatorNaam);
    }

    onNew() {
        redirector.goTo("/e-loket/veldtoertocht/nieuw");
    }

    onMailOpmerkingen() {
        window.location.href = `mailto:${this.context.props.email}?subject=Opmerking%20tocht`;
    }
}